var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJdpanal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 126,
    viewBox: "0 0 27 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58_4928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.57728C5 2.26524 6.59055 1.61291 7.5118 2.54711L21.5775 16.8106C21.8482 17.0851 22 17.4552 22 17.8407V92.2174C22 92.477 21.9311 92.732 21.8003 92.9563L7.73463 117.083C6.98027 118.377 5 117.842 5 116.344V3.57728Z",
    fill: "#DDC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3.57728C5 2.26524 6.59055 1.61291 7.5118 2.54711L21.5775 16.8106C21.8482 17.0851 22 17.4552 22 17.8407V92.2174C22 92.477 21.9311 92.732 21.8003 92.9563L7.73463 117.083C6.98027 118.377 5 117.842 5 116.344V3.57728Z",
    stroke: "#DDC8FF",
    strokeWidth: 0.366787,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 15.4023V95.7288",
    stroke: "url(#paint0_linear_58_4928)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4844 12.8398L17.75 99.7688",
    stroke: "url(#paint1_linear_58_4928)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3516 10.6367V103.801",
    stroke: "url(#paint2_linear_58_4928)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 8.80469V106.737",
    stroke: "url(#paint3_linear_58_4928)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 6.60156V110.769",
    stroke: "url(#paint4_linear_58_4928)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98438 4.76953L8.71423 114.439",
    stroke: "url(#paint5_linear_58_4928)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59375 2.57031L6.32812 118.109",
    stroke: "url(#paint6_linear_58_4928)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9395 80.5098H8.96875V79.0449H14.9395C15.5059 79.0449 15.9883 79.166 16.3867 79.4082C16.7852 79.6504 17.0898 79.9805 17.3008 80.3984C17.5117 80.8164 17.6172 81.291 17.6172 81.8223C17.6172 82.3652 17.5254 82.8477 17.3418 83.2695C17.1582 83.6875 16.877 84.0156 16.498 84.2539C16.1191 84.4922 15.6387 84.6113 15.0566 84.6113V83.1348C15.3926 83.1348 15.6641 83.082 15.8711 82.9766C16.0742 82.8672 16.2227 82.7148 16.3164 82.5195C16.4062 82.3203 16.4512 82.0879 16.4512 81.8223C16.4512 81.5684 16.3945 81.3438 16.2812 81.1484C16.1641 80.9492 15.9941 80.793 15.7715 80.6797C15.5449 80.5664 15.2676 80.5098 14.9395 80.5098ZM17.5 74.873V76.6953L16.334 76.6836V74.873C16.334 74.3457 16.2188 73.9043 15.9883 73.5488C15.7578 73.1895 15.4277 72.9199 14.998 72.7402C14.5684 72.5566 14.0566 72.4648 13.4629 72.4648H13C12.5391 72.4648 12.1309 72.5176 11.7754 72.623C11.4199 72.7246 11.1211 72.877 10.8789 73.0801C10.6367 73.2793 10.4531 73.5254 10.3281 73.8184C10.2031 74.1074 10.1406 74.4414 10.1406 74.8203V76.7305H8.96875V74.8203C8.96875 74.2539 9.06445 73.7363 9.25586 73.2676C9.44336 72.7988 9.71484 72.3945 10.0703 72.0547C10.4258 71.7109 10.8516 71.4473 11.3477 71.2637C11.8438 71.0801 12.3984 70.9883 13.0117 70.9883H13.4629C14.0762 70.9883 14.6309 71.0801 15.127 71.2637C15.623 71.4473 16.0488 71.7109 16.4043 72.0547C16.7559 72.3984 17.0273 72.8086 17.2188 73.2852C17.4062 73.7578 17.5 74.2871 17.5 74.873ZM8.96875 75.8809H17.5V77.3516H8.96875V75.8809ZM14.3184 63.2832V65.5039H13.1523V63.2832C13.1523 62.8965 13.0898 62.584 12.9648 62.3457C12.8398 62.1074 12.668 61.9336 12.4492 61.8242C12.2266 61.7109 11.9727 61.6543 11.6875 61.6543C11.418 61.6543 11.166 61.7109 10.9316 61.8242C10.6934 61.9336 10.502 62.1074 10.3574 62.3457C10.2129 62.584 10.1406 62.8965 10.1406 63.2832V65.0527H17.5V66.5234H8.96875V63.2832C8.96875 62.623 9.08594 62.0625 9.32031 61.6016C9.55078 61.1367 9.87109 60.7832 10.2813 60.541C10.6875 60.2988 11.1523 60.1777 11.6758 60.1777C12.2266 60.1777 12.6992 60.2988 13.0938 60.541C13.4883 60.7832 13.791 61.1367 14.002 61.6016C14.2129 62.0625 14.3184 62.623 14.3184 63.2832ZM16.2285 55.4961H13.2051C12.9785 55.4961 12.7832 55.5371 12.6191 55.6191C12.4551 55.7012 12.3281 55.8262 12.2383 55.9941C12.1484 56.1582 12.1035 56.3652 12.1035 56.6152C12.1035 56.8457 12.1426 57.0449 12.2207 57.2129C12.2988 57.3809 12.4043 57.5117 12.5371 57.6055C12.6699 57.6992 12.8203 57.7461 12.9883 57.7461V59.1523C12.7383 59.1523 12.4961 59.0918 12.2617 58.9707C12.0273 58.8496 11.8184 58.6738 11.6348 58.4434C11.4512 58.2129 11.3066 57.9375 11.2012 57.6172C11.0957 57.2969 11.043 56.9375 11.043 56.5391C11.043 56.0625 11.123 55.6406 11.2832 55.2734C11.4434 54.9023 11.6855 54.6113 12.0098 54.4004C12.3301 54.1855 12.7324 54.0781 13.2168 54.0781H16.0352C16.3242 54.0781 16.584 54.0586 16.8145 54.0195C17.041 53.9766 17.2383 53.916 17.4062 53.8379H17.5V55.2852C17.3477 55.3516 17.1543 55.4043 16.9199 55.4434C16.6816 55.4785 16.4512 55.4961 16.2285 55.4961ZM13.6445 55.291L14.5176 55.2793V56.293C14.5176 56.5547 14.543 56.7852 14.5938 56.9844C14.6406 57.1836 14.7109 57.3496 14.8047 57.4824C14.8984 57.6152 15.0117 57.7148 15.1445 57.7812C15.2773 57.8477 15.4277 57.8809 15.5957 57.8809C15.7637 57.8809 15.918 57.8418 16.0586 57.7637C16.1953 57.6855 16.3027 57.5723 16.3809 57.4238C16.459 57.2715 16.498 57.0879 16.498 56.873C16.498 56.584 16.4395 56.332 16.3223 56.1172C16.2012 55.8984 16.0547 55.7266 15.8828 55.6016C15.707 55.4766 15.541 55.4102 15.3848 55.4023L16.0117 54.9453C16.1719 54.9922 16.3438 55.0723 16.5273 55.1855C16.7109 55.2988 16.8867 55.4473 17.0547 55.6309C17.2188 55.8105 17.3535 56.0273 17.459 56.2812C17.5645 56.5312 17.6172 56.8203 17.6172 57.1484C17.6172 57.5625 17.5352 57.9316 17.3711 58.2559C17.2031 58.5801 16.9785 58.834 16.6973 59.0176C16.4121 59.2012 16.0898 59.293 15.7305 59.293C15.3945 59.293 15.0977 59.2305 14.8398 59.1055C14.5781 58.9766 14.3594 58.7891 14.1836 58.543C14.0078 58.293 13.875 57.9883 13.7852 57.6289C13.6914 57.2695 13.6445 56.8594 13.6445 56.3984V55.291ZM12.5137 51.2012H17.5V52.6133H11.1602V51.2832L12.5137 51.2012ZM14.0957 51.4531L14.0898 51.9102C13.6406 51.9062 13.2285 51.8438 12.8535 51.7227C12.4785 51.5977 12.1563 51.4258 11.8867 51.207C11.6172 50.9844 11.4102 50.7188 11.2656 50.4102C11.1172 50.1016 11.043 49.7578 11.043 49.3789C11.043 49.0742 11.0859 48.7988 11.1719 48.5527C11.2539 48.3027 11.3887 48.0898 11.5762 47.9141C11.7637 47.7344 12.0078 47.5977 12.3086 47.5039C12.6055 47.4102 12.9707 47.3633 13.4043 47.3633H17.5V48.7812H13.3984C13.0938 48.7812 12.8535 48.8262 12.6777 48.916C12.498 49.002 12.3711 49.1289 12.2969 49.2969C12.2188 49.4609 12.1797 49.666 12.1797 49.9121C12.1797 50.1543 12.2305 50.3711 12.332 50.5625C12.4336 50.7539 12.5723 50.916 12.748 51.0488C12.9238 51.1777 13.127 51.2773 13.3574 51.3477C13.5879 51.418 13.834 51.4531 14.0957 51.4531ZM17.6172 43.127C17.6172 43.5957 17.541 44.0195 17.3887 44.3984C17.2324 44.7734 17.0156 45.0938 16.7383 45.3594C16.4609 45.6211 16.1348 45.8223 15.7598 45.9629C15.3848 46.1035 14.9805 46.1738 14.5469 46.1738H14.3125C13.8164 46.1738 13.3672 46.1016 12.9648 45.957C12.5625 45.8125 12.2188 45.6113 11.9336 45.3535C11.6445 45.0957 11.4238 44.791 11.2715 44.4395C11.1191 44.0879 11.043 43.707 11.043 43.2969C11.043 42.8438 11.1191 42.4473 11.2715 42.1074C11.4238 41.7676 11.6387 41.4863 11.916 41.2637C12.1895 41.0371 12.5156 40.8691 12.8945 40.7598C13.2734 40.6465 13.6914 40.5898 14.1484 40.5898H14.752L14.752 45.4883H13.7383V41.9844H13.627C13.373 41.9922 13.1348 42.043 12.9121 42.1367C12.6895 42.2266 12.5098 42.3652 12.373 42.5527C12.2363 42.7402 12.168 42.9902 12.168 43.3027C12.168 43.5371 12.2188 43.7461 12.3203 43.9297C12.418 44.1094 12.5605 44.2598 12.748 44.3809C12.9355 44.502 13.1621 44.5957 13.4277 44.6621C13.6895 44.7246 13.9844 44.7559 14.3125 44.7559H14.5469C14.8242 44.7559 15.082 44.7188 15.3203 44.6445C15.5547 44.5664 15.7598 44.4531 15.9355 44.3047C16.1113 44.1562 16.25 43.9766 16.3516 43.7656C16.4492 43.5547 16.498 43.3145 16.498 43.0449C16.498 42.7051 16.4297 42.4023 16.293 42.1367C16.1562 41.8711 15.9629 41.6406 15.7129 41.4453L16.4336 40.7012C16.6328 40.8379 16.8242 41.0156 17.0078 41.2344C17.1875 41.4531 17.334 41.7207 17.4473 42.0371C17.5605 42.3496 17.6172 42.7129 17.6172 43.127ZM8.5 37.9766H17.5V39.3945H8.5V37.9766Z",
    fill: "url(#paint7_linear_58_4928)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58_4928",
    x: 0.816406,
    y: 1.92383,
    width: 25.3672,
    height: 124.074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_4928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_4928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_4928",
    x1: 19.375,
    y1: 15.4023,
    x2: 19.375,
    y2: 95.7288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_4928",
    x1: 16.9844,
    y1: 12.8428,
    x2: 17.4909,
    y2: 99.7703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_4928",
    x1: 14.8516,
    y1: 10.6367,
    x2: 14.8516,
    y2: 103.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_4928",
    x1: 12.7422,
    y1: 8.80469,
    x2: 12.7422,
    y2: 106.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_58_4928",
    x1: 10.6094,
    y1: 6.60156,
    x2: 10.6094,
    y2: 110.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_58_4928",
    x1: 8.48438,
    y1: 4.76718,
    x2: 7.96929,
    y2: 114.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_58_4928",
    x1: 6.09375,
    y1: 2.56812,
    x2: 5.58728,
    y2: 118.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_58_4928",
    x1: 13.5,
    y1: 84.8867,
    x2: 13.5,
    y2: 36.8867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41245E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdpanal);
export default __webpack_public_path__ + "static/media/Jd panal.cf79f58b9ccec3cfad57b6f392cb8b6b.svg";
export { ForwardRef as ReactComponent };